import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'AssessmentForms';

const AssessmentFormsApi: any = baseApi(endpoint);

export default AssessmentFormsApi;